import * as React from "react";

function CopyExternal(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path
        d="M16.218 1.348a4.314 4.314 0 00-6.265 0l-.714.742a.75.75 0 001.082 1.04l.713-.743a2.814 2.814 0 014.102 0c1.152 1.2 1.152 3.155 0 4.355l-3.24 3.371c-.18.187-.375.344-.581.47a2.81 2.81 0 01-3.52-.47 3.056 3.056 0 01-.405-.525.75.75 0 00-1.28.782c.17.278.37.54.603.783a4.31 4.31 0 005.387.708c.315-.193.61-.43.878-.709l3.24-3.37c1.71-1.78 1.71-4.655 0-6.434z"
        fill="#333"
      />
      <path
        d="M10.787 6.348a4.314 4.314 0 00-6.265 0l-3.24 3.37c-1.71 1.78-1.71 4.655 0 6.434a4.314 4.314 0 006.265 0l.714-.742a.75.75 0 00-1.082-1.04l-.713.743a2.815 2.815 0 01-4.102 0c-1.152-1.2-1.152-3.155 0-4.355l3.24-3.371a2.815 2.815 0 014.101 0c.156.162.291.339.405.525a.75.75 0 001.28-.782c-.17-.278-.37-.54-.603-.782z"
        fill="#333"
      />
    </svg>
  );
}

export default CopyExternal;
